var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": function ($event) {
              _vm.tableData = []
              _vm.searchAct()
            },
          },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "线上数据", name: "1" } }),
          _c("el-tab-pane", { attrs: { label: "本地数据", name: "0" } }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "search_group" },
        [
          _c("date-range-destructor", {
            attrs: {
              start: _vm.startUpdateTime,
              end: _vm.endUpdateTime,
              "start-placeholder": "创建开始时间",
              "end-placeholder": "创建结束时间",
              "value-format": "yyyy-MM-dd",
              type: "daterange",
              format: "yyyy-MM-dd",
            },
            on: {
              "update:start": function ($event) {
                _vm.startUpdateTime = $event
              },
              "update:end": function ($event) {
                _vm.endUpdateTime = $event
              },
            },
          }),
          _c(
            "el-select",
            {
              attrs: { size: "small", clearable: "", placeholder: "上架状态" },
              on: { change: _vm.searchAct },
              model: {
                value: _vm.formStatus,
                callback: function ($$v) {
                  _vm.formStatus = $$v
                },
                expression: "formStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "上架", value: 1 } }),
              _c("el-option", { attrs: { label: "下架", value: 2 } }),
            ],
            1
          ),
          _vm.activeName == "0"
            ? _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "审核状态",
                  },
                  on: { change: _vm.searchAct },
                  model: {
                    value: _vm.formCheckStatus,
                    callback: function ($$v) {
                      _vm.formCheckStatus = $$v
                    },
                    expression: "formCheckStatus",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "待审批", value: 0 } }),
                  _c("el-option", { attrs: { label: "待审核", value: 1 } }),
                  _c("el-option", { attrs: { label: "审核通过", value: 2 } }),
                  _c("el-option", { attrs: { label: "审核不通过", value: 3 } }),
                  _c("el-option", { attrs: { label: "审批不通过", value: 4 } }),
                ],
                1
              )
            : _vm._e(),
          _c("el-input", {
            attrs: { maxlength: 30, size: "small", placeholder: "视频标题" },
            model: {
              value: _vm.formName,
              callback: function ($$v) {
                _vm.formName = $$v
              },
              expression: "formName",
            },
          }),
          _c(
            "el-select",
            {
              attrs: {
                size: "small",
                filterable: "",
                "allow-create": "",
                clearable: "",
                "default-first-option": "",
                placeholder: "输入标签对视频分组",
              },
              model: {
                value: _vm.selectValue,
                callback: function ($$v) {
                  _vm.selectValue = $$v
                },
                expression: "selectValue",
              },
            },
            _vm._l(_vm.selectOptions, function (item) {
              return _c(
                "el-option",
                {
                  key: item.deptName,
                  attrs: { label: item.groupName, value: item.groupName },
                },
                [
                  _c("span", { staticStyle: { float: "left" } }, [
                    _vm._v(_vm._s(item.groupName)),
                  ]),
                  _c(
                    "span",
                    {
                      staticStyle: {
                        float: "right",
                        color: "#8492a6",
                        "font-size": "13px",
                      },
                    },
                    [_vm._v(_vm._s(item.deptName))]
                  ),
                ]
              )
            }),
            1
          ),
          _c(
            "el-select",
            {
              ref: "selectUpResId",
              attrs: { size: "small", clearable: "", placeholder: "所属企业" },
              on: { clear: _vm.handleClear },
              model: {
                value: _vm.selectedId,
                callback: function ($$v) {
                  _vm.selectedId = $$v
                },
                expression: "selectedId",
              },
            },
            [
              _c("el-option", {
                key: "selectedId",
                attrs: {
                  hidden: "",
                  value: _vm.selectedId,
                  label: _vm.selectetName,
                },
              }),
              _c("el-tree", {
                attrs: {
                  data: _vm.deptTreeList,
                  props: _vm.defaultProps,
                  "expand-on-click-node": false,
                  "check-on-click-node": true,
                },
                on: { "node-click": _vm.handleNodeClick },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { icon: "el-icon-search", size: "small", type: "primary" },
              on: { click: _vm.searchAct },
            },
            [_vm._v("搜索")]
          ),
          _c(
            "el-button",
            {
              attrs: {
                icon: "el-icon-download",
                size: "small",
                type: "warning",
              },
              on: { click: _vm.handleExport },
            },
            [_vm._v("导出")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          key: _vm.activeName,
          attrs: {
            "max-height": _vm.tableHeight,
            "element-loading-text": "加载中",
            border: "",
            data: _vm.tableData,
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "200" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "视频标题",
              width: "350",
              align: "left",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "封面", width: "200", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("img", {
                      staticStyle: { height: "50px" },
                      attrs: { src: scope.row.coverImageUrl },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "视频", width: "200", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("img", {
                      staticStyle: { cursor: "pointer" },
                      attrs: { src: scope.row.coverImageUrl, height: "50px" },
                      on: {
                        click: function ($event) {
                          return _vm.openVideo(scope.row)
                        },
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "groupName",
              label: "分组标签",
              width: "100",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "descInfo",
              label: "描述",
              align: "left",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "playTimes",
              label: "累计观看",
              width: "100",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "favorTimes", label: "喜欢", width: "50" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "deptName",
              label: "所属企业",
              width: "150",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "videoStatus", label: "转码状态", width: "100" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.videoStatus == 1
                            ? "上传成功"
                            : scope.row.videoStatus == 2
                            ? "转码中"
                            : scope.row.videoStatus == 3
                            ? "转码成功"
                            : scope.row.videoStatus == 4
                            ? "转码失败"
                            : ""
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "上架状态",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          scope.row.status == 1
                            ? "上架"
                            : scope.row.status == 2
                            ? "下架"
                            : ""
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "reviewStatus",
              label: "审核状态",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.videoIsinWhatstatus(scope.row)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "updateUserName",
              label: "更新人",
              width: "100",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { prop: "updateTime", label: "更新时间", align: "center" },
          }),
          _vm.activeName == "0"
            ? _c("el-table-column", {
                attrs: {
                  fixed: "right",
                  width: "300",
                  label: "操作",
                  align: "center",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.contentStatus == 1 &&
                          scope.row.reviewStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "contentmanage_content_approval",
                                      expression:
                                        "'contentmanage_content_approval'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCheck(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("审批")]
                              )
                            : _vm._e(),
                          scope.row.contentStatus == 2 &&
                          scope.row.reviewStatus == 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "contentmanage_content_examine",
                                      expression:
                                        "'contentmanage_content_examine'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-info",
                                    size: "mini",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openCheck(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("审核")]
                              )
                            : _vm._e(),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "auth",
                                  rawName: "v-auth",
                                  value: "contentmanage_content_viewlog",
                                  expression: "'contentmanage_content_viewlog'",
                                },
                              ],
                              attrs: {
                                icon: "el-icon-view",
                                size: "mini",
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.openLog(scope.row)
                                },
                              },
                            },
                            [_vm._v("查看日志")]
                          ),
                          _vm.activeName == "0" &&
                          scope.row.contentStatus != 3 &&
                          scope.row.contentStatus != 1
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "contentmanage_content_update",
                                      expression:
                                        "'contentmanage_content_update'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-edit",
                                    size: "small",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("修改")]
                              )
                            : _vm._e(),
                          _vm.activeName == "0"
                            ? _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "auth",
                                      rawName: "v-auth",
                                      value: "contentmanage_content_del",
                                      expression: "'contentmanage_content_del'",
                                    },
                                  ],
                                  attrs: {
                                    icon: "el-icon-delete",
                                    size: "small",
                                    type: "text",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.delDiscount(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("删除")]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4257829000
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table_pagination" },
        [
          _c("el-pagination", {
            staticClass: "app-pagination",
            attrs: {
              background: "",
              "current-page": _vm.pageNo,
              "page-sizes": _vm.pageSizeArr,
              "page-size": _vm.pageSize,
              layout: _vm.paginationLayout,
              total: _vm.totalEl,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          ref: "ruleForm",
          attrs: {
            title: _vm.checkItem.contentStatus == 1 ? "审批" : "审核",
            visible: _vm.showCheck,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCheck = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.checkItem,
                size: "mini",
                "label-width": "110px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "视频ID" } }, [
                _vm._v(_vm._s(_vm.checkItem.id)),
              ]),
              _c("el-form-item", { attrs: { label: "所属企业" } }, [
                _vm._v(_vm._s(_vm.checkItem.deptName)),
              ]),
              _c("el-form-item", { attrs: { label: "视频标题" } }, [
                _vm._v(_vm._s(_vm.checkItem.name)),
              ]),
              _vm.checkItem.contentStatus == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "视频资源" } },
                    [
                      _c(
                        "el-table",
                        { attrs: { data: _vm.checkItem.playInfo } },
                        [
                          _c("el-table-column", {
                            attrs: { label: "文件类型", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        _vm._s(
                                          scope.row.definition == "od" ||
                                            scope.row.definition == "OD"
                                            ? "原始文件"
                                            : "转码文件"
                                        )
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              159355649
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              property: "format",
                              label: "格式",
                              width: "200",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { property: "definition", label: "分辨率" },
                          }),
                          _c("el-table-column", {
                            attrs: { property: "bitrate", label: "码率" },
                          }),
                          _c("el-table-column", {
                            attrs: { property: "width", label: "地址" },
                          }),
                          _c("el-table-column", {
                            attrs: { property: "size", label: "大小" },
                          }),
                          _vm.activeName == "0"
                            ? _c("el-table-column", {
                                attrs: {
                                  fixed: "right",
                                  width: "250",
                                  label: "操作",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "text",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openVideo(
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("预览")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  643355188
                                ),
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkItem.contentStatus == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "视频资源" } },
                    [
                      _c(
                        "el-image",
                        {
                          attrs: {
                            src: _vm.checkItem.coverImageUrl,
                            fit: _vm.fit,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "image-slot",
                              staticStyle: { width: "120px", height: "70px" },
                              attrs: { slot: "placeholder" },
                              slot: "placeholder",
                            },
                            [
                              _vm._v("\n            加载中"),
                              _c("span", { staticClass: "dot" }, [
                                _vm._v("..."),
                              ]),
                            ]
                          ),
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "viewbigImg",
                          on: {
                            click: function ($event) {
                              return _vm.openVideo(_vm.checkItem)
                            },
                          },
                        },
                        [_vm._v("预览")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "视频封面" } },
                [
                  _c(
                    "el-image",
                    {
                      attrs: { src: _vm.checkItem.coverImageUrl, fit: _vm.fit },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          staticStyle: { width: "120px", height: "70px" },
                          attrs: { slot: "placeholder" },
                          slot: "placeholder",
                        },
                        [
                          _vm._v("\n            加载中"),
                          _c("span", { staticClass: "dot" }, [_vm._v("...")]),
                        ]
                      ),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      staticClass: "viewbigImg",
                      on: { click: _vm.showViewbigImg },
                    },
                    [_vm._v("查看大图")]
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        title: "",
                        visible: _vm.viewbigImg,
                        modal: false,
                        "modal-append-to-body": false,
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.viewbigImg = $event
                        },
                      },
                    },
                    [
                      _c("img", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.viewbigImg,
                            expression: "viewbigImg",
                          },
                        ],
                        attrs: {
                          src: _vm.checkItem.coverImageUrl,
                          width: "100%",
                          height: "100%",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "分组标签" } }, [
                _vm._v(_vm._s(_vm.checkItem.groupName)),
              ]),
              _c("el-form-item", { attrs: { label: "描述" } }, [
                _vm._v(_vm._s(_vm.checkItem.descInfo)),
              ]),
              _vm.checkItem.contentStatus == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "视频分类", required: "true" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { max: "3" },
                          model: {
                            value: _vm.checkItem.catalogs,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "catalogs", $$v)
                            },
                            expression: "checkItem.catalogs",
                          },
                        },
                        _vm._l(_vm.catalogList, function (item) {
                          return _c(
                            "el-checkbox-button",
                            { key: item.id, attrs: { label: item.id } },
                            [_vm._v(_vm._s(item.catalogName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkItem.contentStatus == 2
                ? _c(
                    "el-form-item",
                    { attrs: { label: "视频分类", max: "3" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: { disabled: "true" },
                          model: {
                            value: _vm.checkItem.catalogs,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "catalogs", $$v)
                            },
                            expression: "checkItem.catalogs",
                          },
                        },
                        _vm._l(_vm.checkItem.catalogName, function (item) {
                          return _c("el-checkbox-button", { key: item.index }, [
                            _vm._v(_vm._s(item)),
                          ])
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkItem.contentStatus == 2 &&
              _vm.checkItem.reviewStatus == 1
                ? _c(
                    "el-form-item",
                    _vm._l(_vm.checkItem.schemaData, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "checkitemcheck" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "跳转应用" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: "请选择跳转应用",
                                    disabled: "",
                                  },
                                  model: {
                                    value: item.appId,
                                    callback: function ($$v) {
                                      _vm.$set(item, "appId", $$v)
                                    },
                                    expression: "item.appId",
                                  },
                                },
                                _vm._l(_vm.appInfoData, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.appName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "AndroidScheme" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: item.androidSchema,
                                  callback: function ($$v) {
                                    _vm.$set(item, "androidSchema", $$v)
                                  },
                                  expression: "item.androidSchema",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "iOSScheme" } },
                            [
                              _c("el-input", {
                                attrs: { disabled: "" },
                                model: {
                                  value: item.iosSchema,
                                  callback: function ($$v) {
                                    _vm.$set(item, "iosSchema", $$v)
                                  },
                                  expression: "item.iosSchema",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-form-item"),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm.checkItem.contentStatus == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "审批意见", required: "true" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.checkItem.reviewStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "reviewStatus", $$v)
                            },
                            expression: "checkItem.reviewStatus",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.checkItem.reviewStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.checkItem, "reviewStatus", $$v)
                                },
                                expression: "checkItem.reviewStatus",
                              },
                            },
                            [_vm._v("审批通过")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 3 },
                              model: {
                                value: _vm.checkItem.reviewStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.checkItem, "reviewStatus", $$v)
                                },
                                expression: "checkItem.reviewStatus",
                              },
                            },
                            [_vm._v("审批不通过")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkItem.reviewStatus != "3" &&
              _vm.checkItem.contentStatus == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "审批后展示", required: "true" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.checkItem.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.checkItem, "status", $$v)
                            },
                            expression: "checkItem.status",
                          },
                        },
                        [
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 1 },
                              model: {
                                value: _vm.checkItem.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.checkItem, "status", $$v)
                                },
                                expression: "checkItem.status",
                              },
                            },
                            [_vm._v("上架")]
                          ),
                          _c(
                            "el-radio",
                            {
                              attrs: { label: 2 },
                              model: {
                                value: _vm.checkItem.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.checkItem, "status", $$v)
                                },
                                expression: "checkItem.status",
                              },
                            },
                            [_vm._v("下架")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.checkItem.reviewStatus == "1" &&
              _vm.checkItem.contentStatus == 2
                ? _c("el-form-item", { attrs: { label: "上架状态" } }, [
                    _vm._v(_vm._s(_vm.checkItem.status == 1 ? "上架" : "下架")),
                  ])
                : _vm._e(),
              _vm.checkItem.reviewStatus == "3" &&
              _vm.checkItem.contentStatus == 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "理由", required: "true" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: 150,
                          resize: "none",
                          placeholder: "请输入不通过的理由",
                        },
                        model: {
                          value: _vm.checkItem.checkMark,
                          callback: function ($$v) {
                            _vm.$set(_vm.checkItem, "checkMark", $$v)
                          },
                          expression: "checkItem.checkMark",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _vm.checkItem.contentStatus == 2
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "contentmanage_content_examine",
                          expression: "'contentmanage_content_examine'",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitcheck(_vm.checkItem, 2)
                        },
                      },
                    },
                    [_vm._v("通过审核")]
                  )
                : _vm._e(),
              _vm.checkItem.contentStatus == 2
                ? _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "contentmanage_content_examine",
                          expression: "'contentmanage_content_examine'",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "danger",
                        icon: "el-icon-circle-close",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitcheck(_vm.checkItem, 3)
                        },
                      },
                    },
                    [_vm._v("拒绝审核")]
                  )
                : _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "auth",
                          rawName: "v-auth",
                          value: "contentmanage_content_approval",
                          expression: "'contentmanage_content_approval'",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.changeCheck(_vm.checkItem)
                        },
                      },
                    },
                    [_vm._v("审批完成")]
                  ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showCheck = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "操作日志",
            visible: _vm.showLog,
            "append-to-body": "",
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showLog = $event
            },
          },
        },
        [
          _c(
            "el-table",
            { attrs: { "max-height": 400, border: "", data: _vm.logData } },
            [
              _c("el-table-column", {
                attrs: { prop: "applyUserName", label: "申请人" },
              }),
              _c("el-table-column", {
                attrs: { prop: "applyTime", label: "申请时间", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "operationType", label: "操作类型" },
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewUserName", label: "审核人" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "reviewContent",
                  "show-overflow-tooltip": "",
                  label: "审核内容",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "reviewTime", label: "审核时间", width: "180" },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      _vm.showLog = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          key: _vm.key,
          attrs: {
            title: "修改视频内容",
            visible: _vm.showEdit,
            "append-to-body": "",
            width: "40%",
            "before-close": _vm.handleAddOrEditClose,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showEdit = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.checkItem,
                size: "mini",
                "label-width": "110px",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "视频ID" } }, [
                _vm._v(_vm._s(_vm.checkItem.id)),
              ]),
              _c("el-form-item", { attrs: { label: "所属企业" } }, [
                _vm._v(_vm._s(_vm.checkItem.deptName)),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "视频标题", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { type: "text", size: "small" },
                    model: {
                      value: _vm.checkItem.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.checkItem, "name", $$v)
                      },
                      expression: "checkItem.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "视频资源" } },
                [
                  _c(
                    "el-table",
                    { attrs: { data: _vm.checkItem.playInfo } },
                    [
                      _c("el-table-column", {
                        attrs: {
                          property: "",
                          label: "文件类型",
                          width: "150",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    scope.row.definition == "od" ||
                                      scope.row.definition == "OD"
                                      ? "原始文件"
                                      : "转码文件"
                                  )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          property: "format",
                          label: "格式",
                          width: "200",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: { property: "definition", label: "分辨率" },
                      }),
                      _c("el-table-column", {
                        attrs: { property: "bitrate", label: "码率" },
                      }),
                      _c("el-table-column", {
                        attrs: { property: "width", label: "地址" },
                      }),
                      _c("el-table-column", {
                        attrs: { property: "size", label: "大小" },
                      }),
                      _vm.activeName == "0"
                        ? _c("el-table-column", {
                            attrs: {
                              fixed: "right",
                              width: "250",
                              label: "操作",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: "el-icon-delete",
                                            size: "small",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openVideo(scope.row)
                                            },
                                          },
                                        },
                                        [_vm._v("预览")]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2518358258
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: "#",
                        "on-change": _vm.handleChangeVideo,
                        "file-list": _vm.fileList,
                        "on-preview": _vm.handlePreview,
                        "auto-upload": false,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("重新上传")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "el-upload__tip",
                          attrs: { slot: "tip" },
                          slot: "tip",
                        },
                        [_vm._v("只能上传.mp4视频文件，且不超过1G")]
                      ),
                    ],
                    1
                  ),
                  _vm.showProgress
                    ? _c("el-progress", {
                        attrs: {
                          percentage: _vm.authProgress,
                          color: "#409eff",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "视频封面" } },
                [
                  _c(
                    "el-upload",
                    {
                      attrs: {
                        action: "#",
                        "list-type": "picture-card",
                        "on-preview": _vm.handleImgsPreview,
                        "auto-upload": false,
                        accept: ".jpeg,.jpg,.png",
                        "file-list": _vm.fileImgesList,
                        "on-exceed": _vm.onexceedVideo,
                        "on-change": _vm.handleChangeImgs,
                        "on-remove": _vm.handleRemove,
                      },
                    },
                    [
                      _c(
                        "el-button",
                        { attrs: { size: "small", type: "primary" } },
                        [_vm._v("重新上传")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(
                    "\n            只能上传jpg、jpeg和png，大小不超过500K\n          "
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        visible: _vm.dialogImageVisible,
                        "append-to-body": "",
                      },
                      on: {
                        "update:visible": function ($event) {
                          _vm.dialogImageVisible = $event
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.dialogImageUrl,
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "标签分组" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        "allow-create": "",
                        "default-first-option": "",
                        placeholder: "输入标签对视频分组",
                      },
                      model: {
                        value: _vm.selectValue,
                        callback: function ($$v) {
                          _vm.selectValue = $$v
                        },
                        expression: "selectValue",
                      },
                    },
                    _vm._l(_vm.selectOptions, function (item) {
                      return _c(
                        "el-option",
                        {
                          key: item.deptName,
                          attrs: {
                            label: item.groupName,
                            value: item.groupName,
                          },
                        },
                        [
                          _c("span", { staticStyle: { float: "left" } }, [
                            _vm._v(_vm._s(item.groupName)),
                          ]),
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "right",
                                color: "#8492a6",
                                "font-size": "13px",
                              },
                            },
                            [_vm._v(_vm._s(item.deptName))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "描述" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      maxlength: 60,
                      resize: "none",
                      placeholder: "请输入视频描述,最多60个汉字",
                    },
                    model: {
                      value: _vm.checkItem.descInfo,
                      callback: function ($$v) {
                        _vm.$set(_vm.checkItem, "descInfo", $$v)
                      },
                      expression: "checkItem.descInfo",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "视频分类" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      attrs: { max: "3" },
                      model: {
                        value: _vm.checkItem.catalogs,
                        callback: function ($$v) {
                          _vm.$set(_vm.checkItem, "catalogs", $$v)
                        },
                        expression: "checkItem.catalogs",
                      },
                    },
                    _vm._l(_vm.catalogList, function (item) {
                      return _c(
                        "el-checkbox-button",
                        { key: item.id, attrs: { label: item.id } },
                        [_vm._v(_vm._s(item.catalogName))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "选择跳转应用" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { clearable: "", placeholder: "请选择跳转应用" },
                      on: {
                        change: function ($event) {
                          return _vm.selectName(_vm.form.appId)
                        },
                      },
                      model: {
                        value: _vm.form.appId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "appId", $$v)
                        },
                        expression: "form.appId",
                      },
                    },
                    _vm._l(_vm.appInfoData, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.appName, value: item.id },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "20px" },
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: { click: _vm.addItem },
                    },
                    [_vm._v("增加")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Androidscheme" } },
                [
                  _c("el-input", {
                    attrs: { type: "text", size: "small" },
                    model: {
                      value: _vm.form.androidSchema,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "androidSchema", $$v)
                      },
                      expression: "form.androidSchema",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "iOSscheme" } },
                [
                  _c("el-input", {
                    attrs: { type: "text", size: "small" },
                    model: {
                      value: _vm.form.iosSchema,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "iosSchema", $$v)
                      },
                      expression: "form.iosSchema",
                    },
                  }),
                ],
                1
              ),
              _vm._l(_vm.form.dynamicItem, function (item, index) {
                return _c(
                  "div",
                  { key: item.id },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "选择跳转应用" } },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              clearable: "",
                              placeholder: "请选择跳转应用",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.moreSelectName(
                                  item.appId,
                                  index,
                                  item
                                )
                              },
                            },
                            model: {
                              value: item.appId,
                              callback: function ($$v) {
                                _vm.$set(item, "appId", $$v)
                              },
                              expression: "item.appId",
                            },
                          },
                          _vm._l(_vm.appInfoData, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.appName, value: item.id },
                            })
                          }),
                          1
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "20px" },
                            attrs: {
                              size: "small",
                              type: "warning",
                              icon: "el-icon-circle-check",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.deleteItem(item, index)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Androidscheme" } },
                      [
                        _c("el-input", {
                          model: {
                            value: item.androidSchema,
                            callback: function ($$v) {
                              _vm.$set(item, "androidSchema", $$v)
                            },
                            expression: "item.androidSchema",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "iOSscheme" } },
                      [
                        _c("el-input", {
                          model: {
                            value: item.iosSchema,
                            callback: function ($$v) {
                              _vm.$set(item, "iosSchema", $$v)
                            },
                            expression: "item.iosSchema",
                          },
                        }),
                      ],
                      1
                    ),
                    _c("el-form-item"),
                  ],
                  1
                )
              }),
              _c(
                "el-form-item",
                { attrs: { label: "状态" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.checkItem.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.checkItem, "status", $$v)
                        },
                        expression: "checkItem.status",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 1 },
                          model: {
                            value: _vm.status,
                            callback: function ($$v) {
                              _vm.status = $$v
                            },
                            expression: "status",
                          },
                        },
                        [_vm._v("上架")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: 2 },
                          model: {
                            value: _vm.status,
                            callback: function ($$v) {
                              _vm.status = $$v
                            },
                            expression: "status",
                          },
                        },
                        [_vm._v("下架")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "auth",
                      rawName: "v-auth",
                      value: "contentmanage_content_update",
                      expression: "'contentmanage_content_update'",
                    },
                  ],
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.submitEdit(_vm.checkItem)
                    },
                  },
                },
                [_vm._v("保存修改")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.showEdit = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "视频播放",
            "append-to-body": "",
            width: "50%",
            visible: _vm.dialogShowPlayVideo,
            "before-close": _vm.handleVideoClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogShowPlayVideo = $event
            },
          },
        },
        [
          _c(
            "video",
            {
              attrs: {
                src: _vm.playURL,
                id: "vide",
                controls: "controls",
                width: "100%",
              },
            },
            [
              _vm._v(
                "\n       your browser does not support the video tag\n    "
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }